module.exports = __webpack_public_path__ + "img/server-2.84bd4b2.png";